import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { WORKSPACE_SEARCH_API } from '../data-sources';
import { WORKSPACE_SEARCH_REPOSITORY } from '../../core';
export var WorkspaceSearchRepository = /*#__PURE__*/function () {
  function WorkspaceSearchRepository(workspaceApi) {
    _classCallCheck(this, WorkspaceSearchRepository);

    this.workspaceApi = workspaceApi;
  }

  _createClass(WorkspaceSearchRepository, [{
    key: "workspaceSearch",
    value: function () {
      var _workspaceSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var responseOrError, workspaceSearchResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.workspaceApi.workspaceSearch(query);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                workspaceSearchResponse = responseOrError.getValue();
                return _context.abrupt("return", Result.ok(workspaceSearchResponse));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function workspaceSearch(_x) {
        return _workspaceSearch.apply(this, arguments);
      }

      return workspaceSearch;
    }()
  }]);

  return WorkspaceSearchRepository;
}();
export var workspaceSearchRepositoryProvider = {
  provide: WORKSPACE_SEARCH_REPOSITORY,
  useFactory: function useFactory(workspaceSearchApi) {
    return new WorkspaceSearchRepository(workspaceSearchApi);
  },
  inject: [WORKSPACE_SEARCH_API]
};